import React from 'react';

import { View } from '@rbilabs/universal-components';

import { useMatch } from 'state/location';
import { routes } from 'utils/routing';

import { OffersUIProvider } from './offers-ui-context';
import { OffersRouter } from './routes';

const Container = View.withConfig({
  flex: 1,
  width: 'full',
  minHeight: '1/2',
  flexDirection: {
    md: 'row',
  },
});

interface IUIRefreshOffersViewProps {
  suffixUrl: string;
  currentUrl: string;
  urlOfferId: string | null;
}

const UIRefreshOffersView: React.FC<React.PropsWithChildren<IUIRefreshOffersViewProps>> = ({
  suffixUrl,
  currentUrl,
  urlOfferId,
}) => {
  return (
    <OffersUIProvider suffixUrl={suffixUrl} currentUrl={currentUrl} urlOfferId={urlOfferId}>
      <Container>
        <OffersRouter />
      </Container>
    </OffersUIProvider>
  );
};

/**
 * This component grabs the `offerId` from the URL and passes it to the main Offers view.
 * The url is the source of truth for which offer is selected/previewed. This plays a critical role
 * in navigation, sub-routing, and shareability of offers!
 */
export interface IUIRefreshOffersProps {
  suffixUrl?: string;
  currentUrl?: string;
}

export const UIRefreshOffers: React.FC<React.PropsWithChildren<IUIRefreshOffersProps>> = ({
  suffixUrl = '/',
  currentUrl = routes.offers,
}) => {
  const match = useMatch(`${currentUrl}${suffixUrl}/*`);
  const offerIdSlug = match?.params['*']!;

  return (
    <UIRefreshOffersView urlOfferId={offerIdSlug} suffixUrl={suffixUrl} currentUrl={currentUrl} />
  );
};
